import { useEffect, useState } from 'react';
import { Button, Dialog, MarkdownField } from 'src/components';
import { FormLabel, Grid } from '@material-ui/core';
import { type ICourse } from 'src/models';
import { useDispatch } from 'react-redux';
import courseActions from 'src/store/Courses/actions';

interface Props {
	open: boolean;
	handleOpen: () => void;
	courseId: number;
	instructions?: string;
}

function InstructionsDialog({
	courseId,
	handleOpen,
	instructions,
	open,
}: Props) {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const updateInstructions = (course: ICourse) =>
		dispatch(courseActions.updateInstructions(course));
	const [newInstructions, setNewInstructions] = useState<string>();

	useEffect(() => {
		setNewInstructions(instructions || '');
	}, [instructions]);

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[77:8]
	function handleSave() {
		updateInstructions({
			id: courseId,
			instructions: newInstructions,
		});

		handleOpen();
	}

	return (
		<Dialog
			actions={
				<Button
					actionType={'save'}
					disabled={newInstructions?.length === 0}
					onClick={handleSave}
				>
					Guardar
				</Button>
			}
			content={
				<Grid container>
					<Grid item xs={12}>
						<FormLabel> Instrucciones de examen </FormLabel>

						<MarkdownField
							onChange={(value: string) => {
								setNewInstructions(value);
							}}
							value={newInstructions}
						/>
					</Grid>
				</Grid>
			}
			handleOpen={handleOpen}
			maxWidth={'md'}
			open={open}
			title={'Instrucciones en examen'}
		/>
	);
}

export default InstructionsDialog;
